import { Injectable } from '@angular/core';

// Retains the File of an in-flight video upload so an errored upload can be retried with the
// same in-memory bytes — the store can't hold the File (non-serializable) and the upload stream
// drops its reference once it settles. Released when the video succeeds or leaves the store.
// Keyed by videoId alone: it is either a generated UUID or the server session token, both globally
// unique, so no client code or sequence id is needed to disambiguate it.
@Injectable({ providedIn: 'root' })
export class VideoUploadFileService {
  private readonly fileByVideo = new Map<string, File>();

  retain(videoId: string, file: File): void {
    this.fileByVideo.set(videoId, file);
  }

  get(videoId: string): File | undefined {
    return this.fileByVideo.get(videoId);
  }

  release(videoId: string): void {
    this.fileByVideo.delete(videoId);
  }

  // Drops every retained File at once. Logout wipes the store in a single action, so there is no
  // per-video removal to hook onto and the whole map would stay pinned in memory.
  clear(): void {
    this.fileByVideo.clear();
  }
}
